import React from 'react'

const ReportListIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        stroke={color}
        strokeWidth="10"
        fill={color}
        d="M93.1 1.6c-9.4 3.3-16.7 9.9-21.8 19.6l-2.8 5.3v458l2.7 5.7c3.5 7.6
      9.9 14.3 17.3 18.1l6 3.2h323l5.8-2.9c7.1-3.6 14-10.8
      17.5-18.4l2.7-5.7.3-84.2c.2-83.3.2-84.3-1.8-86.3-2.6-2.6-8-2.6-11.1-.1l-2.4
      1.9-.5 82.9c-.5 74.7-.7 83.1-2.2 85.8-2.1 3.8-6.3 7.7-10.8 10.1-3.4
      1.8-9.2 1.9-159
      1.9H100.5l-4-2.2c-5.1-2.7-9-6.8-10.9-11.5-1.4-3.3-1.6-27.4-1.6-226.8s.2-223.5
      1.6-226.8c1.9-4.7 5.8-8.8 10.9-11.5l4-2.2 102.3-.3 102.2-.3V45h-89.1c-99.9
      0-93.6-.5-98.7 7.3l-2.7 4.1v49.3l2.9 3.7c1.6 2.1 4.7 4.7 7 5.7 3.9 1.8 8.1
      1.9 81.4 1.9 75.6 0 77.2 0 79.2-2 2.9-2.9 3.4-6.3
      1.6-9.9-.9-1.7-1.8-3.2-1.9-3.3-.1-.2-34.8-.5-77.2-.8l-77-.5-.3-19.4c-.2-14.9.1-19.6
      1-20.3.7-.4 40.1-.8 87.6-.8H305v22.3c0 24.9.9 30.8 6.1 38.9 4.1 6.4 9 10.5
      16.9 14.2l6.5 3.1 46.7.3 46.8.3.2 74.5.3 74.6 2.9 2.5c3.3 2.8 7.5 2.6
      10.8-.4 1.7-1.5 1.8-5.6 1.8-82.7v-81.1l-63.3-63.2L317.5 0h-110C110.9.1 97
      .3 93.1 1.6zm286.3 121.2c-23
      .1-39-.2-41.3-.8-7.8-2.1-13.9-8.2-16.1-15.9-.6-2.1-1-19.2-1-41.6v-38l48 48
      48 48-37.6.3z"
      />
      <path
        stroke={color}
        strokeWidth="10"
        fill={color}
        d="M120.9 154.3c-6.7 4.4-6.9 5.7-6.9 39.5 0 28.1.1 30.6 2 34.1 1.3 2.7 3.3 4.6 6.3 6 4.1 2 5.9 2.1 33.7 2.1 27.3 0 29.7-.1 33.5-2 2.6-1.3 4.9-3.4 6.3-5.9 2.1-3.7 2.2-4.9 2.2-34.2 0-33.9-.2-35.2-6.9-39.6-3.4-2.3-3.8-2.3-35.1-2.3s-31.7 0-35.1 2.3zM182 194v26h-52v-52h52v26zM229.1 154.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6zM229.1 184.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6zM120.9 267.3c-6.7 4.4-6.9 5.7-6.9 39.5 0 28.1.1 30.6 2 34.1 1.3 2.7 3.3 4.6 6.3 6 4.1 2 5.9 2.1 33.7 2.1 27.3 0 29.7-.1 33.5-2 2.6-1.3 4.9-3.4 6.3-5.9 2.1-3.7 2.2-4.9 2.2-34.2 0-33.9-.2-35.2-6.9-39.6-3.4-2.3-3.8-2.3-35.1-2.3s-31.7 0-35.1 2.3zM182 307v26h-52v-52h52v26zM229.1 267.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6zM229.1 297.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6zM120.9 380.3c-6.7 4.4-6.9 5.7-6.9 39.5 0 28.1.1 30.6 2 34.1 1.3 2.7 3.3 4.6 6.3 6 4.1 2 5.9 2.1 33.7 2.1 27.3 0 29.7-.1 33.5-2 2.6-1.3 4.9-3.4 6.3-5.9 2.1-3.7 2.2-4.9 2.2-34.2 0-33.9-.2-35.2-6.9-39.6-3.4-2.3-3.8-2.3-35.1-2.3s-31.7 0-35.1 2.3zM182 420v26h-52v-52h52v26zM229.1 380.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6zM229.1 410.6c-2.6 3.3-2.7 7.5-.2 10.5l1.9 2.4h159.4l1.9-2.4c2.5-3 2.4-7.2-.2-10.5l-2-2.6H231.1l-2 2.6z"
      />
    </svg>
  )
}

ReportListIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default ReportListIcon
